<template>
  <div class="page page_home">
    <HomeHero />
    <HomeIdea />
    <HomeForWho />
    <HomeHowItWorks />
    <HomeHowToBuy />
  </div>
</template>

<script>
import HomeHero from '@/components/home/HomeHero.vue'
import HomeIdea from '@/components/home/HomeIdea.vue'
import HomeHowItWorks from '@/components/home/HomeHowItWorks.vue'
import HomeForWho from '@/components/home/HomeForWho.vue'
import HomeHowToBuy from '@/components/home/HomeHowToBuy.vue'

export default {
  name: 'Home',
  components: { HomeHero, HomeIdea, HomeHowItWorks, HomeForWho, HomeHowToBuy }
}
</script>

<style lang="scss" scoped>
@import "../styles/_variables.scss";

.page {
  padding: 0;
  max-width: none;
  margin: 0;

  &_home {
    min-height: auto;
  }
}
</style>
